import React, { useState, useEffect, Fragment } from "react";
import ApiCaller from "api/apiCaller";
import PopupMenu from './PopupMenu';
import "./index.css";

export default function NotiButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [unread, setUnread] = useState(false);

  const search = window.location.search;
  const searchParams = new URLSearchParams(search);
  const readNotificationId = searchParams.get('read_notification_id') || null;
  
  const tooglePopupMenu = () => {
    setIsOpen(!isOpen);
  }
  const getNotificationCount = async () => {
    const res = await ApiCaller.get("notification/unread/count");
    if (res?.count) {
      setUnread(res?.count);
    } else {
      console.log(res);
    }
  }; 
  const markNotiAsRead = async () => {
    if (readNotificationId) {
      const res = await ApiCaller.post(`notification/read/${readNotificationId}`);
    }
  }
  useEffect(() => {
    getNotificationCount();
    markNotiAsRead();
  }, []);
  
  return (
    <Fragment>
      <div style={styles.notiButtonContainer}>
        <span
          onClick={tooglePopupMenu}
          style={styles.notiButton}
        >
          <span className={`noti-button__unread-count ${unread ? 'unread' : ''}`}>
            {unread}
          </span>
        </span>
        {isOpen &&
          <PopupMenu
            tooglePopupMenu={tooglePopupMenu}
          />
        }
      </div>
    </Fragment>
  );
}

const styles = {
  notiButtonContainer: {
    display: 'flex',
    justifyItems: 'center',
    alignContent: 'center',
  },
  notiButton: {
    background: 'none',
    border: 'none',
  }
};
